export default __webpack_public_path__ + "static/media/ModalLogo.5d8aaf10.png";